import script from "./ImageBlockMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageBlockMenu.vue?vue&type=script&setup=true&lang=js"

import "./ImageBlockMenu.vue?vue&type=style&index=0&id=27b343af&lang=scss"

const __exports__ = script;

export default __exports__